import { RanchSeasonDTO } from "../dtos/RanchSeasonDTO";
import { toDateStringOrUndefined } from "../types/datestring.types";
import { ingestAPIObject } from "../utils/api";
export class BaseYieldStatisticDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
        this.date = toDateStringOrUndefined(jsonData.date);
        this.estimate = jsonData.estimate ?? 0;
        this.actual = jsonData.actual ?? 0;
    }
}
// Ranch-specific yield statistics
export class RanchYieldStatisticDTO extends BaseYieldStatisticDTO {
    constructor(jsonData) {
        super(jsonData); // Call the parent constructor to handle common fields
        // Handle ranch-specific fields
        this.ranchId = jsonData.ranchId ?? 0;
        this.ranchName = jsonData.ranchName ?? "";
        this.growerName = jsonData.growerName ?? "";
    }
}
// Daily total yield statistics with ranch breakdowns
export class DayTotalYieldStatisticDTO extends BaseYieldStatisticDTO {
    constructor(jsonData) {
        super(jsonData); // Call the parent constructor to handle common fields
        // Handle the ranch overviews
        this.ranchOverviews = (jsonData.ranchOverviews || []).map((ranchOverview) => new RanchYieldStatisticDTO(ranchOverview));
    }
}
// Unified data point that combines actuals, estimates, and model data
export class UnifiedHarvestDataPointDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
        this.date = toDateStringOrUndefined(jsonData.date);
    }
}
export class HarvestOverviewRanchDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
        // Convert season objects if they exist
        this.seasons = (jsonData.seasons || []).map((season) => new RanchSeasonDTO(season));
    }
}
